// extracted by mini-css-extract-plugin
export default {"section":"SectionHeading_section__or4CD","section__header":"SectionHeading_section__header__t7d86","section__heading":"SectionHeading_section__heading__jgU3r"};